const formatTime = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export default function ChatBubble({ message }) {
  const isOutbound = message.direction === "OUTBOUND";

  return (
    <div className={`flex ${isOutbound ? "justify-end" : "justify-start"} mb-3`}>
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2.5 ${
          isOutbound
            ? "bg-blue-600 text-white rounded-br-md"
            : "bg-gray-200 text-gray-900 rounded-bl-md"
        }`}
      >
        <p className="text-sm whitespace-pre-wrap break-words">{message.body}</p>
        <div
          className={`flex items-center gap-2 mt-1 text-xs ${
            isOutbound ? "text-blue-200" : "text-gray-500"
          }`}
        >
          <span>{formatTime(message.created_at)}</span>
          {message.step_number && (
            <span className={`px-1.5 py-0.5 rounded ${
              isOutbound ? "bg-blue-500" : "bg-gray-300 text-gray-600"
            }`}>
              Step {message.step_number}
            </span>
          )}
          {isOutbound && message.status && (
            <span>{message.status === "delivered" ? "✓✓" : message.status === "sent" ? "✓" : ""}</span>
          )}
        </div>
      </div>
    </div>
  );
}
